import api from "./api";

const abbreviateAddress = (address, address2) => {
  return new Promise((resolve, reject) => {
    api
      .get("/api/abbreviate-addresses/", {
        params: {
          address1: address,
          address2,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { abbreviateAddress };
